var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.storage = void 0;
const store_1 = __importDefault(require("store"));
exports.storage = {
    get: key => {
        const stored = store_1.default.get(key);
        if (!stored)
            return null;
        try {
            const item = JSON.parse(stored);
            const now = new Date();
            if ((item === null || item === void 0 ? void 0 : item.expiry) && now.getTime() > (item === null || item === void 0 ? void 0 : item.expiry)) {
                store_1.default.remove(key);
                return null;
            }
            return item === null || item === void 0 ? void 0 : item.value;
        }
        catch (e) {
            return stored;
        }
    },
    set: (key, value, days = 0) => {
        const now = new Date();
        const expiry = days && now.getTime() + days * 86400000;
        const item = {
            value,
            expiry,
        };
        store_1.default.set(key, JSON.stringify(item));
    },
    setAll: items => items.map(item => store_1.default.set(item === null || item === void 0 ? void 0 : item.key, item === null || item === void 0 ? void 0 : item.value)),
    remove: key => store_1.default.remove(key),
    wipe: () => store_1.default.clearAll(),
    all: () => {
        const output = [];
        store_1.default.each((value, key) => {
            output.push({ key, value });
        });
        return output;
    },
};
//# sourceMappingURL=store.js.map